const VideoButton = {
  cfg: {
    buttons: document.querySelectorAll('.js-videobutton')
  },
  addHandler: button => {
    button.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();

      // Add overlay
      const overlay = document.createElement('div');
      overlay.classList.add('c-videobutton__overlay');

      // Add video embed
      const video = document.createElement('video');
      video.classList.add('c-videobutton__video');
      video.setAttribute('autoplay', '');
      video.setAttribute('controls', '');
      video.setAttribute('width', '960');
      video.setAttribute('height', '506');
      const src = document.createElement('source');
      src.setAttribute('src', e.target.href);
      src.setAttribute('type', 'video/mp4');
      video.appendChild(src);

      overlay.appendChild(video);
      document.getElementById('__root').appendChild(overlay);

      const onClose = () => {
        const overlay = document.querySelector('.c-videobutton__overlay');
        overlay.classList.remove('c-videobutton__overlay--visible');
        setTimeout(() => overlay.parentNode.removeChild(overlay), 500);
      }

      setTimeout(() => overlay.classList.add('c-videobutton__overlay--visible'), 10);
      overlay.addEventListener('click', onClose);

      return false;
    });
  },
  init() {
    if (typeof this.cfg.buttons !== undefined && this.cfg.buttons !== null) {
      this.cfg.buttons.forEach(this.addHandler);
    }
  }
};

export default VideoButton;